import api from './api';

const sectionCommentService = {
  /**
   * Create a new comment or reply
   */
  createComment: async (projectId, data) => {
    const response = await api.post(`/comments/projects/${projectId}`, data);
    return response.data.data;
  },

  /**
   * Get all comments for a section (with replies)
   */
  getSectionComments: async (conversationId, sectionId, includeResolved = false) => {
    const response = await api.get(
      `/comments/conversations/${conversationId}/sections/${sectionId}`,
      { params: { include_resolved: includeResolved } }
    );
    return response.data.data;
  },

  /**
   * Get comment counts per section (for badges)
   */
  getCommentCounts: async (conversationId, taskId) => {
    const response = await api.get(
      `/comments/conversations/${conversationId}/counts`,
      { params: { task_id: taskId } }
    );
    return response.data.data;
  },

  /**
   * Update a comment
   */
  updateComment: async (commentId, content) => {
    const response = await api.patch(`/comments/${commentId}`, { content });
    return response.data.data;
  },

  /**
   * Resolve a comment
   */
  resolveComment: async (commentId) => {
    const response = await api.post(`/comments/${commentId}/resolve`);
    return response.data.data;
  },

  /**
   * Reopen a resolved comment
   */
  reopenComment: async (commentId) => {
    const response = await api.post(`/comments/${commentId}/reopen`);
    return response.data.data;
  },

  /**
   * Delete a comment
   */
  deleteComment: async (commentId) => {
    const response = await api.delete(`/comments/${commentId}`);
    return response.data;
  },
};

export default sectionCommentService;
